import { render, staticRenderFns } from "./EditRatificaciones.vue?vue&type=template&id=062d3438"
import script from "./EditRatificaciones.vue?vue&type=script&lang=js"
export * from "./EditRatificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('062d3438')) {
      api.createRecord('062d3438', component.options)
    } else {
      api.reload('062d3438', component.options)
    }
    module.hot.accept("./EditRatificaciones.vue?vue&type=template&id=062d3438", function () {
      api.rerender('062d3438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/tasks/EditRatificaciones.vue"
export default component.exports